import { useState, useContext } from "react";
import { mensajeSimple, mensajeEstatico, modalCargando, modalComentario, modalEjecutar, modalAprobarSolicitud, modalRechazarSolicitud, modalGuardandoCambiosModal, mensajeExitoModal } from "../../../components/ui/sweetAlerts";
import { validaGetStatus, cerrarSession, hideSideBarDesktop, cierraModal } from "../../../utils/funciones";
import { ACEPTA_CAMBIO_CARGO, objStyleCol, RECHAZA_CAMBIO_CARGO } from "../../../utils/Constants";
import { DataContext, DataContextContractual } from "../../../contextData/contextData";
import { faEye, faHistory, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CambioCargo } from "../../cambio-de-cargo/CambioCargo";
import { getUno, postWithResponse, deleteWithResponse } from "../../../api/apis";
import { useLocation } from "react-router-dom";
import { ModalVerSolicitudAdmin } from "./ModalVerSolicitudAdmin";
import { ModalVerSolicitud } from "./ModalVerSolicitud";
import { useIndex } from "../../useIndex";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import moment from "moment";

export const removerDataInnecesaria = obj => {
  let obj_n = JSON.parse(JSON.stringify(obj));
  if (![4].includes(obj.id_tipo_solicitud)) {
    delete obj_n.tipo_cambio_contrato
  }

  return obj_n
}

export const Celda = props => {
  const { label, ancho } = props;
  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: ancho,
      }}
      title={label}
    >
      {label}
    </div>
  )
}
Celda.propTypes = {
  label: PropTypes.string,
  ancho: PropTypes.string,
}

export const CeldaHeader = ({ alineacion, label }) => {
  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: alineacion || "left",
        width: "100%",
      }}
      title={label}
    >
      {label}
    </div>
  )
}
CeldaHeader.propTypes = {
  alineacion: PropTypes.string,
  label: PropTypes.string.isRequired,
}

export const useSolicitudesCurso = () => {
  const {
    dataListado, setDataListado, setVisibleModalForm, dataModalForm, setDataModalForm,
    diasAnticipo, diasAnticipoGeneral, obtenerDiasAnticipoPorTipo,
    visibleEditarModal, setVisibleEditarModal, solicitudEditar, setSolicitudEditar, hideEditarModal
  } = useContext(DataContextContractual);
  const { setUno } = useContext(DataContext);
  const [visible, setVisible] = useState(false);
  const [visibleHistorial, setVisibleHistorial] = useState(false);
  const [dataModal, setdataModal] = useState({});
  const [idSolicitud, setIdSolicitud] = useState(undefined);
  const { formatFecha } = useIndex();
  const location = useLocation();
  const [documentos, setDocumentos] = useState([]);

  const idSolicitudTexto = dataModal?.id ? `#${dataModal.id}` : "";
  const nombreTipo = dataModal?.tipo_solicitud_cambio_contraactual?.nombre || "";

  const objModal = {
    titulo: visibleHistorial
      ? `Historial de la solicitud ${idSolicitudTexto}`.trim()
      : visibleEditarModal
      ? `Editar Solicitud ${idSolicitudTexto} - ${nombreTipo}`.trim()
      : "Información solicitud - " + nombreTipo,
    component: <ModalVerSolicitud obj={dataModal} />
  }

  const objModalAdmin = {
    titulo: visibleHistorial
      ? `Historial de la solicitud ${idSolicitudTexto}`.trim()
      : visibleEditarModal
      ? `Editar Solicitud ${idSolicitudTexto} - ${nombreTipo}`.trim()
      : `Información solicitud ${idSolicitudTexto}`.trim(),
    component: <ModalVerSolicitudAdmin obj={dataModal} />
  }

  const traerDocumentos = async (obj) => {
    const resp = await getUno("documentoscambiocc", { "id_solicitud_cc": obj.id }, null);
    if (resp?.status === 200) {
      setDocumentos(resp.data.data || []);
    }
  }

  const returnTipoContrato = (tipo) => ({
    "01": "Indefinido",
    "02": "Fijo"
  }[tipo] || "No especifíca")

  const returnAccesos = (perfil, id_tipo_solicitud, estado) => {
    let obj = {};
    const noMatch = 12362;
    const tipo = Number(id_tipo_solicitud);
    const est = Number(estado);
    const perf = String(perfil);

    if ([1, 2, 4].includes(tipo)) {
      obj = {
        '2': [1],
        '3': [2, 14],
        '4': [noMatch],
      };
    }

    if ([3].includes(tipo)) {
      obj = {
        '2': [6],
        '3': [10, 14],
        '4': [noMatch],
      };
    }

    if ([5].includes(tipo)) {
      obj = {
        '2': [noMatch],
        '3': [1],
        '4': [noMatch],
      };
    }
    return Boolean(obj[perf]?.includes(est));
  };

  const hideModal = (obj) => {
    const esSolicitudObj = Boolean(obj && typeof obj === "object" && obj.id && !obj.nativeEvent && !obj.target);
    if (esSolicitudObj) {
      setdataModal(obj);
      setVisible(true);
      setVisibleHistorial(false);
      setVisibleEditarModal(false);
      if (String(localStorage.getItem("id_perfil")) === "2") {
        postWithResponse("cc/marcarvisto", null, { id_solicitud: obj.id });
      }
    } else {
      if (obj && !obj.nativeEvent && !obj.target) {
        setdataModal(obj);
      }
      setVisible(false);
      setVisibleHistorial(false);
      setVisibleEditarModal(false);
    }
  }

  const filtrarUno = (obj) => {
    setDataModalForm({ ...dataModalForm, component: <CambioCargo tipo={1} /> });
    if (obj) {
      formik.setValues({ ...formik.values, fecha_inicio_cambio: formatFecha(obj.fecha_inicio_cambio.replaceAll('-', '')) });
      setUno({
        "REEO_NOMBRES": obj.persona.nombre,
        "REEO_APELLIDO_PATERNO": obj.persona.apellido_pat,
        "REEO_TIPO_CONTRATO": obj.persona.tipo_contrato,
        "REEO_RUT": obj.persona.identificacion,
        "ID": obj.id,
        "FECHA_INICIO_CAMBIO": obj.fecha_inicio_cambio,
      });

      return;
    }
    setUno(undefined);
  }

  const validate = (obj) => {
    let errObj = {};
    const diasLimite = obtenerDiasAnticipoPorTipo ? obtenerDiasAnticipoPorTipo(obj?.id_tipo_solicitud) : (diasAnticipoGeneral || diasAnticipo);

    if (!["01"].includes(obj.fecha_inicio_cambio.split("-")[2])) errObj.fecha_inicio_cambio = 'Solo primer día (01) de cada mes';
    if (
      moment(formik.values.fecha_inicio_cambio).diff(moment(new Date()).subtract(diasLimite, "d"), "days")
      <
      moment(formik.values.fecha_inicio_cambio).diff(moment(formik.values.fecha_inicio_cambio).subtract(diasLimite, "d"), "days")
    ) {
      errObj.fecha_inicio_cambio = 'Fecha fuera de rango. Validar con Remuneraciones.';
    }

    if (!obj.cod_sap_nuevo_cargo) errObj.cod_sap_nuevo_cargo = 'Requerido';
    if (!obj.nueva_unidad_organizativa) errObj.nueva_unidad_organizativa = 'Requerido';
    if (!obj.nuevo_plan_horario) errObj.nuevo_plan_horario = 'Requerido';

    return errObj;
  }

  const formik = useFormik({
    initialValues: {
      fecha_inicio_cambio: '',
      cod_sap_nuevo_cargo: '',
      nueva_unidad_organizativa: '',
      nuevo_plan_horario: '',
    },
    validate,
  });

  const enviarData = async (obj, data1, data2, res) => {
    const textoCargando = [4].includes(obj.id_estado_solicitud)
      ? "Enviando a SAP..."
      : obj.aprueba !== false
      ? "Procesando aprobación..."
      : "Procesando rechazo...";

    modalGuardandoCambiosModal(textoCargando);
    cierraModal();

    const resp = await postWithResponse('getlistado', {}, { ...removerDataInnecesaria(obj), observacion: res });
    const validacion = validaGetStatus(resp.status);

    if (validacion) {
      if (!obj.acepta) {
        let tituloExito = "¡Operación exitosa!";
        if ([4].includes(obj.id_estado_solicitud)) {
          tituloExito = "¡Solicitud enviada a SAP exitosamente!";
        } else if (obj.aprueba !== false) {
          tituloExito = "¡Solicitud aprobada exitosamente!";
        } else {
          tituloExito = "¡Solicitud rechazada exitosamente!";
        }

        mensajeExitoModal({
          titulo: tituloExito,
          texto: "",
          tiempo: 2200,
        });
        setTimeout(() => { setDataListado({ ...dataListado, arrData: dataListado.arrData.filter(e => e.id !== obj.id) }); }, 1000);

        if (["/solicitudes-traspaso"].includes(location.pathname)) {
          setTimeout(() => { window.location.reload() }, 2000);
        }
      }
      window.dispatchEvent(new Event("refresh_solicitudes_table"));
      return
    }

    const errorMsg = resp?.data?.message || (resp?.data?.data ? JSON.stringify(resp.data.data, null, 2) : "Error en el servidor");
    mensajeEstatico(resp?.data?.status || "error", "", errorMsg);

    if (["/solicitudes-traspaso"].includes(location.pathname)) {
      setTimeout(() => { window.location.reload() }, 2000);
    }
  }

  const aceptaSolicitud = (props) => {
    if (["/solicitudes-traspaso"].includes(location.pathname) && [1].includes(props.id_estado_solicitud)) {
      cierraModal();
      hideModal();
      filtrarUno(props);
      setVisibleModalForm(true);
      setDataModalForm({
        titulo: "Datos de nueva instalación",
        component: <CambioCargo tipo={1} />,
      });
      return
    }
    modalAprobarSolicitud(() => { enviarData(props, false, false, "") }, ACEPTA_CAMBIO_CARGO, props);
  }

  const rechazaSolicitud = (props) => {
    modalRechazarSolicitud(enviarData, RECHAZA_CAMBIO_CARGO, props);
  }

  const verificarPermisosCancelar = async (idSolicitud) => {
    try {
      const resp = await getUno("verificarpermisoscancelar", { id_solicitud: idSolicitud }, null);
      if (resp?.status === 200 && resp?.data?.data) {
        return resp.data.data;
      }
      return { puede_eliminar: false };
    } catch (error) {
      console.log(error);
      return { puede_eliminar: false };
    }
  }

  const cancelarSolicitud = async (row) => {
    const permisos = await verificarPermisosCancelar(row.id);

    if (!permisos.puede_eliminar) {
      Swal.fire({
        icon: 'error',
        title: 'No tiene permisos',
        text: permisos.mensaje || 'No puede eliminar esta solicitud',
      });
      return;
    }

    Swal.fire({
      title: '¿Está seguro?',
      html: `<p>¿Desea cancelar/eliminar la solicitud de <strong>${row.tipo_solicitud_cambio_contraactual?.nombre || 'cambio contractual'}</strong> para el colaborador <strong>${row.persona?.nombre} ${row.persona?.apellido_pat}</strong>?</p><p class="text-danger mt-2">Esta acción no se puede deshacer.</p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, cancelar solicitud',
      cancelButtonText: 'No, mantener',
    }).then(async (result) => {
      if (result.isConfirmed) {
        modalCargando('Cancelando solicitud...');

        try {
          const resp = await deleteWithResponse('cancelarsolicitud', {}, { id_solicitud: row.id });

          if (resp?.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Solicitud cancelada',
              text: resp.data?.message || 'La solicitud ha sido cancelada exitosamente',
              timer: 2000,
              showConfirmButton: false
            });

            setTimeout(() => {
              traerListado();
              window.dispatchEvent(new Event("refresh_solicitudes_table"));
            }, 1000);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: resp?.data?.message || 'No se pudo cancelar la solicitud',
            });
          }
        } catch (error) {
          console.log(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al cancelar la solicitud',
          });
        }
      }
    });
  }

  const arrColumnas = [
    {
      name: "Colaborador",
      cell: row => <Celda label={row.persona.nombre + " " + row.persona.apellido_pat + " " + row.persona.apellido_mat} ancho='300px' />,
      width: "250px"
    },
    {
      name: <CeldaHeader label="RUT" alineacion="center" />,
      selector: row => row.persona.identificacion,
      width: "90px",
      style: objStyleCol
    },
    {
      name: "Instalación de origen",
      selector: row => row.instalacion_actual || "No Aplica",
      width: "230px",
    },
    {
      name: "Cargo actual",
      cell: row => <Celda label={row.nombre_cargo_actual.split("|")[1]} ancho='230px' />,
      wrap: false,
      width: "230px",
    },
    {
      name: "Nuevo Cargo Temporis",
      cell: row => <Celda label={row.descripcion_unidad_temporis.split(" - ")[1]} ancho='200px' />,
      width: "200px"
    },
    {
      name: <CeldaHeader label="Fecha inicio cambio" alineacion="center" />,
      selector: row => row.fecha_inicio_cambio ? formatFecha(row.fecha_inicio_cambio.replaceAll('-', '')) : "---",
      width: "160px",
      style: objStyleCol
    },
    {
      name: "Tipo solicitud",
      cell: row => <Celda label={row.tipo_solicitud_cambio_contraactual.nombre} ancho='200px' />,
      width: "200px"
    },
    {
      name: "Estado actual",
      cell: row => <Celda label={row.estado_solicitud_cambio_contractual.nombre} ancho='230px' />,
      width: "230px"
    },
    {
      name: 'Acciones',
      width: "200px",
      button: true,
      cell: (row) => {
        const esRRHH = String(localStorage.getItem("id_perfil")) === "3";
        return (
          <div className="d-flex gap-2">
            {(location.pathname === "/historial-solicitudes") ? (
              <button
                className={`btn gap-2 d-flex align-items-center py-0 btn-outline-secondary btn-sm`}
                data-bs-toggle="tooltip" title="Ver historial"
                onClick={() => {
                  setIdSolicitud(row.id);
                  setVisible(!visible);
                }}
              >
                Historial <FontAwesomeIcon icon={faHistory} />
              </button>
            ) : (
              <>
                <button
                  className={`btn gap-2 d-flex align-items-center py-0 btn-${returnAccesos(localStorage.getItem("id_perfil"), row.id_tipo_solicitud, row.id_estado_solicitud) === false ? "outline-secondary" : "primary"} btn-sm`}
                  data-bs-toggle="tooltip" title="Ver solicitud"
                  onClick={() => { hideModal(row) }}
                >
                  VER<FontAwesomeIcon icon={faEye} title='Ver solicitud' />
                </button>
                {esRRHH && (
                  <button
                    className="btn gap-1 d-flex align-items-center py-0 btn-warning btn-sm fw-bold text-dark"
                    title="Editar datos de solicitud"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSolicitudEditar(row);
                      setdataModal(row);
                      setVisible(true);
                      setVisibleEditarModal(true);
                    }}
                  >
                    Editar <FontAwesomeIcon icon={faEdit} />
                  </button>
                )}
              </>
            )}
          </div>
        )
      },
    },
  ]

  const traerListado = async (tipo) => {
    const respListado = await getUno(
      ["/", "/historial-solicitudes", "/solicitudes-en-curso"].includes(location.pathname) ? "getlistado" : "getallporenviarsap",
      ["/envio-a-sap"].includes(location.pathname) && tipo ? ({ tipo_solicitud: tipo }) : null
    );

    hideSideBarDesktop();

    if (!validaGetStatus(respListado)) {
      cerrarSession();
      return;
    }

    const columnass = ["/envio-a-sap"].includes(location.pathname) ? arrColumnas.slice(0, -1) : arrColumnas;

    setDataListado({
      arrData: respListado.data.data,
      id_columnas: columnass,
    });

    Swal.close();
  }

  return {
    objModal, objModalAdmin, visible, setVisible, hideModal, aceptaSolicitud, rechazaSolicitud, idSolicitud, setIdSolicitud, traerDocumentos, documentos,
    traerListado, setDataListado, arrColumnas, returnAccesos, returnTipoContrato, visibleHistorial, setVisibleHistorial,
    cancelarSolicitud, verificarPermisosCancelar, setdataModal,
    visibleEditarModal, hideEditarModal, solicitudEditar, setSolicitudEditar, setVisibleEditarModal
  }
}
